/**
 * Shortcuts for the Cognito user and group types
 */

import { getConfig } from 'src/utils';

export const FederatedUserSignUpKey = getConfig(
  'REACT_APP_FEDERATED_USER_SIGN_UP_KEY',
  'built-federated-user-sign-up'
);

/**
 * A remembered-device record
 */
export interface RememberedDevice {
  created: Date;
  id: string;
  name: string;
  lastAuthenticated: Date;
  lastModified: Date;
  attributes: {
    [name: string]: string;
  };
}

/**
 * A Cognito-formatted remembered-device response from a server
 */
export interface RememberedDeviceResponse {
  Devices: {
    DeviceCreateDate: Date;
    DeviceKey: string;
    DeviceLastAuthenticatedDate: Date;
    DeviceLastModifiedDate: Date;
    DeviceAttributes: {
      Name: string;
      Value: string;
    }[];
  }[];
}

// tslint:disable-next-line:no-any
export function isPasswordLogin(value: any): value is PasswordLoginOptions {
  return value.username != null;
}

// tslint:disable-next-line:no-any
export function isMfaLogin(value: any): value is MfaLoginOptions {
  return value.code != null;
}

export type LoginOptions = PasswordLoginOptions | MfaLoginOptions;

export interface PasswordLoginOptions {
  username: string;
  password: string;
}

export interface MfaLoginOptions {
  /** Verification code for MFA */
  code: string;
  /**
   * The type of MFA this represents, this value should match the value
   * from Cognito when MFA authentication is required.
   */
  mfaType?: string;
  /** Whether to remember this device */
  rememberDevice?: boolean;
}

export enum MfaType {
  sms = 'SMS_MFA',
  totp = 'SOFTWARE_TOKEN_MFA_CODE',
}
